import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Curso } from '../../../../service/types/cursos.types';
import { SimpleUser } from './AsignacionManager';
import AsignacionManager from './AsignacionManager';
import CursoForm from './CursoForm';
import ModuloManager from './ModuloManager';
import ProgresoUsuariosManager from './ProgresoUsuariosManager';

interface CursoEditorProps {
  cursoId?: string;
  initialValue?: Curso;
  fetchUsers: () => Promise<SimpleUser[]>;
}

export default function CursoEditor({ cursoId, initialValue, fetchUsers }: CursoEditorProps) {
  const [curso, setCurso] = useState<Curso | undefined>(initialValue);
  const id = curso?.id ?? cursoId;

  return (
    <div>
      <CursoForm initialValue={curso} onSaved={setCurso} />
      {id && (
        <Tabs defaultActiveKey="modulos" className="mb-3">
          <Tab eventKey="modulos" title="Módulos y páginas">
            <ModuloManager cursoId={id} />
          </Tab>
          <Tab eventKey="asignaciones" title="Asignaciones">
            <AsignacionManager cursoId={id} fetchUsers={fetchUsers} />
          </Tab>
          <Tab eventKey="progreso" title="Progreso">
            <ProgresoUsuariosManager cursoId={id} cursoTitulo={curso?.titulo} />
          </Tab>
        </Tabs>
      )}
      {!id && <p className="text-muted">Guarde el curso para poder administrar sus módulos y asignaciones.</p>}
    </div>
  );
}
